import { Button, Col, DatePicker, Divider, Form, Input, Modal, Row, Select, message } from "antd";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { cerrarSesion } from "../../redux/actions/sesion";
import { maps_key, urlapi } from "../../lib/backend/data";
import { PlusCircleFilled } from "@ant-design/icons";
import CamposObligatoriosLeyenda from "../../subComponents/general/formularios/campos_obligatorios";
import AutoComplete from "react-google-autocomplete";
import { procesarGeoDatosGeocode } from "../../lib/helpers/maps";
import { codigos_area, codigos_pais } from "../../lib/internacional";
import { filterOption, formatYMD } from "../../lib/helpers/helpers";
import Title from "antd/es/typography/Title";
import { GoDeviceMobile } from "react-icons/go";
import { AiOutlineMail } from "react-icons/ai";
import SelectorClientes from "../Clientes/selector";
import { modulo } from "./data";
import dayjs, { locale } from "dayjs";
import { DateTime } from "luxon";
import { FaTruckFront, FaTruckRampBox } from "react-icons/fa6";
import { GiHandTruck } from "react-icons/gi";
import ModalSeleccionVehiculo from "../Vehiculos/modal_seleccion";
import { FaChevronRight, FaRegTrashAlt } from "react-icons/fa";
import SelectorZonaAvanzadoInternacional from "../RadioOperacion/selector_zona_avanzado_internacional";

const CrearNuevoContacto = (props) => {
    const {
        default_payload
    } = props
    const [ campo, setCampo ] = useState(default_payload ? default_payload : {})
    const pais = useSelector(state => state.pais)
    const [ showSelectorCliente, setShowSelectorCliente ] = useState(true)
    const idioma = useSelector(state => state.idioma)
    const session = useSelector(state => state.miusuario)
    const [ vehiculos, setVehiculos ] = useState([])
    const [messageApi, contextHolder] = message.useMessage();
    const [ loading, setLoading ] = useState(false)
    const [ key_input_filter, setKeyInputFilter ] = useState(0)
    const [isModalOpen, setIsModalOpen] = useState(false);
    const dispatch = useDispatch()
    const module = modulo

    const requeridos = [
        { value: 'titulo', label: 'Título' },
        { value: 'tipo_disponibilidad', label: 'Tipo' },
    ];

    useEffect(() => {
        if(default_payload) if(typeof default_payload === "object") if(default_payload.id_cliente) setShowSelectorCliente(false)
    }, [])
    
    const crearCampo = async () => {
        const instancia_campo = { ...campo }
        let faltantes = []
        requeridos.map(field => {
            if(!instancia_campo[field.value]) faltantes.push(field.label)
            return true
        })
        if(faltantes.length > 0) return messageApi.error(`Faltan campos: ${faltantes.join(', ')}`)  
        if(!instancia_campo.ids_origin) return messageApi.error("Debe seleccionar al menos una ubicación de carga")
        if(instancia_campo.ids_origin.length < 1) return messageApi.error("Debe seleccionar al menos una ubicación de carga")
        if(!instancia_campo.ids_destination) return messageApi.error("Debe seleccionar al menos una ubicación de descarga")
        if(instancia_campo.ids_destination.length < 1) return messageApi.error("Debe seleccionar al menos una ubicación de descarga")
        if(vehiculos.length < 1) return messageApi.error("Debe seleccionar al menos un vehículo")
        instancia_campo.vehiculos = vehiculos

        if(instancia_campo.tipo_disponibilidad === "unica"){
            if(!instancia_campo.fecha_carga_desde) return messageApi.error("Debe seleccionar fecha de carga desde")
            if(!instancia_campo.fecha_carga_hasta) return messageApi.error("Debe seleccionar fecha de carga hasta")
            if(!instancia_campo.fecha_descarga_desde) return messageApi.error("Debe seleccionar fecha de descarga desde")
            if(!instancia_campo.fecha_descarga_hasta) return messageApi.error("Debe seleccionar fecha de descarga hasta")

            if(instancia_campo.fecha_carga_desde){
                if(instancia_campo.hora_carga_desde){
                    const horario = instancia_campo.hora_carga_desde.split(":")
                    const desde = DateTime.fromISO(instancia_campo.fecha_carga_desde).set({hour: parseInt(horario[0]), minute: parseInt(horario[1]) }).toUTC().toISO()
                    instancia_campo.fecha_carga_desde = desde
                } else {
                    instancia_campo.fecha_carga_desde = DateTime.fromISO(instancia_campo.fecha_carga_desde).startOf('day').toUTC().toISO()
                }
            }

            if(instancia_campo.fecha_carga_hasta){
                if(instancia_campo.hora_carga_hasta){
                    const horario = instancia_campo.hora_carga_hasta.split(":")
                    const hasta = DateTime.fromISO(instancia_campo.fecha_carga_hasta).set({hour: parseInt(horario[0]), minute: parseInt(horario[1]) }).toUTC().toISO()
                    instancia_campo.fecha_carga_hasta = hasta
                } else {
                    instancia_campo.fecha_carga_hasta = DateTime.fromISO(instancia_campo.fecha_carga_hasta).endOf('day').toUTC().toISO()
                }
            
            }

            if(instancia_campo.fecha_descarga_desde){
                if(instancia_campo.hora_descarga_desde){
                    const horario = instancia_campo.hora_descarga_desde.split(":")
                    const desde = DateTime.fromISO(instancia_campo.fecha_descarga_desde).set({hour: parseInt(horario[0]), minute: parseInt(horario[1]) }).toUTC().toISO()
                    instancia_campo.fecha_descarga_desde = desde
                } else {
                    instancia_campo.fecha_descarga_desde = DateTime.fromISO(instancia_campo.fecha_descarga_desde).startOf('day').toUTC().toISO()
                }
            }

            if(instancia_campo.fecha_descarga_hasta){
                if(instancia_campo.hora_descarga_hasta){
                    const horario = instancia_campo.hora_descarga_hasta.split(":")
                    const hasta = DateTime.fromISO(instancia_campo.fecha_descarga_hasta).set({hour: parseInt(horario[0]), minute: parseInt(horario[1]) }).toUTC().toISO()
                    instancia_campo.fecha_descarga_hasta = hasta
                } else {
                    instancia_campo.fecha_descarga_hasta = DateTime.fromISO(instancia_campo.fecha_descarga_hasta).endOf('day').toUTC().toISO()
                }
            
            }

        }

        setLoading(true)
        return fetch(`${urlapi}/${module}`,{
            method:'POST',
            body: JSON.stringify(instancia_campo),
            headers: {
                'Content-Type':'application/json',
                'Authorization': `Bearer: ${session.tokenSession}`,
                'country': pais,
                'lang': idioma
            }
        })
        .then(res => {
            if(res.status === 401) return dispatch(cerrarSesion())
            return res.json()
        })
        .then(res => {
            if(!res){
                messageApi.error('Sin datos')
                return setLoading(false)
            } else if(res.errorMessage){
                messageApi.error(res.errorMessage)
                return setLoading(false)
            } else if(res._id){
                messageApi.success("Creado exitosamente")
                setIsModalOpen(false)
                setCampo({...{}, ...{}})
                setVehiculos([...[], ...[]])
                if(props.onCreate) props.onCreate()
            }
            return setLoading(false)
        })
        .catch(error => {
            messageApi.error("Error al consultar la información, intente nuevamente")
            return setLoading(false)
        })
    }

    const showModal = () => {
      setIsModalOpen(true);
    };

    const handleOk = () => {
        return crearCampo()
    };
    const handleCancel = () => {
        setIsModalOpen(false);
        return setCampo({...{}, ...{}})
      };

    const handleChange = (e) => {
        const { name, value } = e.target
        return setCampo(prev => {
            let actual = { ...prev }
            actual[name] = value
            return { ...actual, ...{} }
        })
    }

    const handleChangeCustom = (value,name) => {
        campo[name] = value
        console.log(campo)
        return setCampo(campo)
    }


    const handleChangeSelect = (name, value) => {
        return setCampo(prev => {
            let actual = { ...prev }
            actual[name] = value
            return { ...actual, ...{} }
        })
    }

    const mostrarSelectorClientes = () => {
        if(!showSelectorCliente) return false

        return <div>
            <SelectorClientes key={key_input_filter} titulo="Cliente" onChange={(data) => handleChangeCustom(data,'id_cliente') } condicion={{}} />
        </div>
    }

    const remover = (i) => {
        setVehiculos(prev => {
            let actual = [...prev]
            actual.splice(i,1)
            return actual
        })
    }

    const mostrarVehiculos = () => {
        return <div>
            <Divider className="mt-3 mb-3" />
            {
                vehiculos.map((veh,iv) => {
                    return <div key={`veh-${iv}`}>
                        <Row gutter={15}>
                            <Col md={18}><Title level={5} className="mt-0 mb-2"><FaTruckFront style={{ verticalAlign: "middle" }} /> {veh.identificador}</Title></Col>
                            <Col md={6}><Button size="small" icon={<FaRegTrashAlt />} onClick={() => remover(iv)} >REMOVER</Button> </Col>
                        </Row>
                        { vehiculos.length > 1 ? <Divider className="mt-3 mb-3" /> : false}
                    </div>
                })
            }
        </div>
    }

    const handleChangeDate = (e,name, final) => {
        const valor_input = e ? e['$d'] : null
        let valor_utc = valor_input ? DateTime.fromJSDate(e['$d']) : null
        
        if(valor_utc) if(final) valor_utc = valor_utc.endOf('day')
        
        return setCampo(prev => {
            let actual = { ...prev }
            actual[name] = valor_utc ? valor_utc.toUTC().toISO() : null
            return actual
        })
    }

    const mostrarMantenedorFechas = () => {
        if(campo.tipo_disponibilidad === "unica"){
            return <Col md={24}><Row>
                <Col md={24}>
                        <Title level={3} className="mt-0 mb-2"><GiHandTruck style={{ verticalAlign: "middle" }} /> Carga</Title>
                            <Row gutter={15}>
                                <Col xs={24}>
                                    <Row gutter={15}>
                                        <Col md={12}>
                                        <Form.Item label="Desde" className="mb-3">
                                        {/* <DatePicker placeholder="Seleccionar fecha" type style={{ width: "100%"}} format="YYYY-MM-DD" locale={locale} defaultValue={campo.fecha_carga_desde ? dayjs(formatYMD(campo.fecha_carga_desde), 'YYYY-MM-DD') : ""}  onChange={(e) => handleChangeDate(e,'fecha_carga_desde')} /> */}
                                        <Input type="date" name="fecha_carga_desde" value={campo.fecha_carga_desde} onChange={handleChange} />
                                        </Form.Item>
                                        </Col>
                                        <Col md={12}>
                                        <Form.Item label="Hora" className="mb-3">
                                        <Input type="time" style={{ width: "100%"}} name="hora_carga_desde" value={campo.hora_carga_desde} onChange={handleChange} />
                                        </Form.Item>
                                        </Col>
                                    </Row>
                                    
                                    
                                </Col>
                                <Col xs={24}>
                                    <Row gutter={15}>
                                        <Col md={12}>
                                        <Form.Item label="Hasta" className="mb-3">
                                        <Input type="date" name="fecha_carga_hasta" value={campo.fecha_carga_hasta} onChange={handleChange} />
                                        {/* <DatePicker placeholder="Seleccionar fecha" type style={{ width: "100%"}} format="YYYY-MM-DD" locale={locale} defaultValue={campo.fecha_carga_hasta ? dayjs(formatYMD(campo.fecha_carga_hasta), 'YYYY-MM-DD') : ""}  onChange={(e) => handleChangeDate(e,'fecha_carga_hasta')} /> */}
                                        </Form.Item>
                                        </Col>
                                        <Col md={12}>
                                        <Form.Item label="Hora" className="mb-3">
                                        <Input type="time" style={{ width: "100%"}} name="hora_carga_hasta" value={campo.hora_carga_hasta} onChange={handleChange} />
                                        </Form.Item>
                                        </Col>
                                    </Row>
                                   
                                    
                                </Col>
                            </Row>
                    </Col>
                    <Col md={24}>
                        <Title level={3} className="mt-0 mb-2"><FaTruckRampBox style={{ verticalAlign: "middle" }} /> Descarga</Title>
                            <Row gutter={15}>
                                <Col xs={24}>
                                    <Row gutter={15}>
                                    <Col md={12}>
                                    <Form.Item label="Desde" className="mb-3">
                                    {/* <DatePicker placeholder="Seleccionar fecha" type style={{ width: "100%"}} format="YYYY-MM-DD" locale={locale} defaultValue={campo.fecha_carga_desde ? dayjs(formatYMD(campo.fecha_carga_desde), 'YYYY-MM-DD') : ""}  onChange={(e) => handleChangeDate(e,'fecha_carga_desde')} /> */}
                                    <Input type="date" name="fecha_descarga_desde" value={campo.fecha_descarga_desde} onChange={handleChange} />
                                    </Form.Item>
                                    </Col>
                                    <Col md={12}>
                                    <Form.Item label="Hora" className="mb-3">
                                    <Input type="time" style={{ width: "100%"}} name="hora_descarga_desde" value={campo.hora_descarga_desde} onChange={handleChange} />
                                    </Form.Item>
                                    </Col>
                                    </Row>
                                </Col>
                                <Col xs={24}>
                                <Row gutter={15}>
                                    <Col md={12}>
                                    <Form.Item label="Hasta" className="mb-3">
                                    {/* <DatePicker placeholder="Seleccionar fecha" type style={{ width: "100%"}} format="YYYY-MM-DD" locale={locale} defaultValue={campo.fecha_carga_hasta ? dayjs(formatYMD(campo.fecha_carga_hasta), 'YYYY-MM-DD') : ""}  onChange={(e) => handleChangeDate(e,'fecha_carga_hasta')} /> */}
                                    <Input type="date" name="fecha_descarga_hasta" value={campo.fecha_descarga_hasta} onChange={handleChange} />
                                    </Form.Item>
                                    </Col>
                                    <Col md={12}>
                                    <Form.Item label="Hora" className="mb-3">
                                    <Input type="time" style={{ width: "100%"}} name="hora_descarga_hasta" value={campo.hora_descarga_hasta} onChange={handleChange} />
                                    </Form.Item>
                                    </Col>
                                </Row>
                                    
                                    
                                </Col>
                            </Row>
                    </Col>
            </Row>
            </Col>
        } else if (campo.tipo_disponibilidad === "recurrente"){
            return <Col md={24}>
                <Form.Item label="Vencimiento" className="mb-2">
                <Input type="date" name="vencimiento" value={campo.vencimiento} onChange={handleChange} />
                </Form.Item>
                </Col>
        }
    }

    const agregarUbicacion = (data, key) => {
        if(!data) return
        setCampo(prev => {
            let actual = {...prev}
            if(!actual[key]) actual[key] = []
            const i = actual[key].findIndex(e => e._id === data._id)
            if(i < 0) actual[key].push({ _id: data._id, titulo: data.titulo, slug: data.slug })
            return actual
        })
    }

    const mostrarUbicaciones = (key) => {
        if(!campo[key]) return false
        if(campo[key].length < 1) return false
        return <div>
            {
                campo[key].map((ubi,i) => <Title level={4} key={`ubi-${i}`} className="mt-0 mb-2"><FaChevronRight style={{ verticalAlign: "middle" }} /> {ubi.titulo}</Title>)
            }
        </div>
    }
    
    return <div>
        <Button className="mb-3" type="primary" size="small" onClick={() => {
            setKeyInputFilter(key_input_filter + 1)
            return showModal()
        }}><PlusCircleFilled /> CREAR NUEVO</Button>
        <Modal 
            title="Crear nueva disponibilidad " 
            open={isModalOpen} 
            onOk={handleOk} 
            onCancel={handleCancel}
            confirmLoading={loading}
        >
            <CamposObligatoriosLeyenda />
            {/* {mostrarSelectorClientes()} */}
            <Form layout="vertical">
                <Row gutter={15} >
                    {/* <Col md={24}>
                        <Form.Item label="Estado" className="mb-2">
                        <Select options={[{ value: 'active', label: "Activo" },{ value: "inactive", label: "Inactivo" }]} showSearch filterOption={filterOption} defaultValue={!campo.status ? "" : campo.status} name="status" onChange={(e) => handleChangeSelect("status", e)} />
                        </Form.Item>
                    </Col> */}
                    <Col md={12}>
                        <Form.Item label="Título" required className="mb-2">
                        <Input name="titulo" value={campo.titulo} onChange={handleChange} />
                        </Form.Item>
                    </Col>
                    <Col md={12}>
                        <Form.Item label="Tipo" required className="mb-2">
                        <Select options={[{ value: 'recurrente', label: "Recurrente" },{ value: "unica", label: "Única" }]} showSearch filterOption={filterOption} defaultValue={!campo.tipo_disponibilidad ? "" : campo.tipo_disponibilidad} name="tipo_disponibilidad" onChange={(e) => handleChangeSelect("tipo_disponibilidad", e)} />
                        </Form.Item>
                    </Col>                    
                    
                    {mostrarMantenedorFechas()}
                    <Col md={24}>
                        <Divider className="mt-3 mb-3" />
                        <Title level={4} className="mt-0 mb-2">Ubicación de carga</Title>
                        <SelectorZonaAvanzadoInternacional onSelected={(data) => agregarUbicacion(data,'ids_origin')} />
                        {mostrarUbicaciones('ids_origin')}
                        <Divider className="mt-3 mb-3" />
                        <Title level={4} className="mt-0 mb-2">Ubicación de descarga</Title>
                        <SelectorZonaAvanzadoInternacional onSelected={(data) => agregarUbicacion(data,'ids_destination')} />
                        {mostrarUbicaciones('ids_destination')}
                    </Col>
                    <Col md={24}>
                        <Divider className="mt-3 mb-3" />
                        <Title level={4} className="mt-0 mb-2">Vehículos asociados { vehiculos.length > 0 ? <Button size="small" icon={<FaRegTrashAlt />} onClick={() => setVehiculos([...[], ...[]])} >REMOVER TODO</Button> : false } </Title>
                            <ModalSeleccionVehiculo isMulti={true} showSelection={true} hideSeleccionados={true}  onSelect={data => {
                                let valor = data
                                setVehiculos(prev => {
                                    let actual = [ ...prev ]
                                    for( const veh of valor ){
                                        veh.identificador = veh.titulo
                                        const i = actual.findIndex(e => e._id === veh._id)
                                        if( i < 1 ) actual.push(veh) 
                                    }
                                    return actual
                                })
                            }} />
                        
                        {mostrarVehiculos()}
                    </Col>
                </Row>
            </Form>
      </Modal>
      {contextHolder}
    </div>
}

export default CrearNuevoContacto